export default __webpack_public_path__ + "8caf8c6259d549dfdda81d5e3b51764b.png";